import { useMutation, useQuery } from "@tanstack/react-query";
import { useToast } from "../../../components/toast/useToast";
import { axiosInstance } from "./JsdhNotifikaceService";
import { handleRequest } from "../../axios";
import { FEEDBACK_URL, DEMO_STATUS_URL } from "../url";

export interface CreateFeedbackRequest {
    unitCode: string;
    unitName?: string;
    autorJmeno: string;
    autorEmail?: string;
    typ: 'BUG' | 'NAVRH';
    kategorie: 'FRONTEND' | 'SYSTEM' | 'JINE';
    predmet: string;
    popis: string;
    metadata?: string;
}

interface FeedbackResponse {
    id: number;
    stav: string;
    message: string;
}

const FeedbackService = {
    submit: (data: CreateFeedbackRequest): Promise<FeedbackResponse> =>
        handleRequest(() => axiosInstance.post(FEEDBACK_URL, data)),
};

export const useSubmitFeedbackMutation = () => {
    const { showToast } = useToast();

    return useMutation<FeedbackResponse, Error, CreateFeedbackRequest>({
        mutationFn: (data) => FeedbackService.submit(data),
        onSuccess: () => {
            showToast("Děkujeme za vaši zpětnou vazbu!", "success");
        },
        onError: (error) => {
            showToast(error.message || "Chyba při odesílání", "error");
        },
    });
};

export const useDemoStatusQuery = () => {
    return useQuery<{ demoEnabled: boolean }>({
        queryKey: ['demoStatus'],
        queryFn: () => handleRequest(() => axiosInstance.get(DEMO_STATUS_URL)),
        staleTime: 10 * 60 * 1000,
        retry: false,
    });
};
